export const ROOT = 'StepOne/form/modelVehicle';

export const FETCH_MODEL_VEHICLE_REQUEST = `${ROOT}/FETCH_MODEL_VEHICLE_REQUEST`;
export const FETCH_MODEL_VEHICLE_FAILURE = `${ROOT}/FETCH_MODEL_VEHICLE_FAILURE`;
export const FETCH_MODEL_VEHICLE_SUCCESS = `${ROOT}/FETCH_MODEL_VEHICLE_SUCCESS`;

export const SET_MODEL_VEHICLE_MESSAGE = `${ROOT}/SET_MODEL_VEHICLE_MESSAGE`;
export const SET_MODEL_VEHICLE_SELECTED = `${ROOT}/SET_MODEL_VEHICLE_SELECTED`;

export const CLEAR_MODEL_VEHICLE_MESSAGE = `${ROOT}/CLEAR_MODEL_VEHICLE_MESSAGE`;
export const CLEAR_MODEL_VEHICLE_DATA = `${ROOT}/CLEAR_MODEL_VEHICLE_DATA`;
export const CLEAR_MODEL_VEHICLE_SELECTED = `${ROOT}/CLEAR_MODEL_VEHICLE_SELECTED`;
